export default __webpack_public_path__ + "static/media/red.8ecbe234.svg";